import { Provider } from './lpk-run-context.jsx';
import { LimeSection } from './LimeSection.jsx';
import { YieldSection } from './YieldSection.jsx';
import { NutrientSelectors } from './NutrientSelectors.jsx';
import { PhosphorusSection } from './PhosphorusSection.jsx';
import { PotassiumSection } from './PotassiumSection.jsx';

export function LpkInputs() {
  return (
    <Provider>
      <NutrientSelectors />
      <LimeSection />
      <PhosphorusSection />
      <PotassiumSection />
      <YieldSection />
    </Provider>
  );
}
